import { ProjectCommitteeInput } from './create-new-project-committees-input';

export interface UpdateProjectCommitteeInput {
  projectId: string;
  committeeId: string;
  committee: ProjectCommitteeInput;
}
